module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg5-0850de82cbf0bf6dc14ce6dbf0a29f6c.jpg";